__turbopack_context__.v({
  "container": "UcORTa_container",
});
